export const VARIATION_SEPARATOR = '_#_#_'

export const getVariationUid = (product, variation = null) => {
  return variation
    ? product.uid + VARIATION_SEPARATOR + variation.id.text
    : product.uid
}
